module.exports = __webpack_public_path__ + "static/img/registerBj.cefd04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gytb/registerBj.png
// module id = GUoh
// module chunks = 13